import React from 'react';

import { Box, Stack, TitleGroup } from '@ekhodealer/ekho-common/rev';

import type { Section, SettingsGroup, Subsection } from '@ekhodealer/ekho-common';

export interface SubsectionProps {
	group: SettingsGroup;
	section: Section;
	subsection: Subsection;
	title: string;
	description?: string;
	children: React.ReactNode;
}

/**
 * Subsection component - represents a nested section within a form section.
 * Similar to the "Primary Contract Signer" card in SaleServiceForm.
 * Visibility is controlled by the parent form component.
 */
export function Subsection({ title, description, children }: SubsectionProps) {
	return (
		<>
			<Box padding='20' background='secondary'>
				<Stack itemsSpacing='16'>
					<TitleGroup title={title} level='subgroup' description={description} />
					{children}
				</Stack>
			</Box>
		</>
	);
}
